// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9085ee9763de4e85853c","655":"ae1054522f49580946c0"}[chunkId] + ".js";
};